export default class PasswordRequestController {
  constructor($state, PasswordRecoveryService, Notification) {
    this.state = $state;
    this.service = PasswordRecoveryService;
    this.notify = Notification;
  }

  $onInit(){
    this.subscriptions = [];

    this.email = '';
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  requestPassword(){
    this.subscriptions.push(
      this.service.requestPassword(this.email).subscribe(
        (data) => {
          this.state.go('requestSuccess', {email: this.email});
        },
        (err) => {
          console.log(err);
        }
      )
    );
  }
}

 PasswordRequestController.$inject = ['$state', 'PasswordRecoveryService', 'Notification'];



// WEBPACK FOOTER //
// ./src/app/pages/password-request/password-request.controller.js